<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState['isMobile'],
    headerStyle () {
      let stickyInfo = {
        isOn: true,
        isSwitchTheme: false,
        switchTheme: 'white', // 吸顶时主题
        triggerScrollTop: 1,
        top: 0
      }
      let theme = 'white'
      let rootPosition = 'static'

      function getHeaderStyle (headerStyle) {
        if (headerStyle.hasOwnProperty('theme')) {
          theme = headerStyle.theme
        }
        if (headerStyle.hasOwnProperty('position')) {
          rootPosition = headerStyle.position
        }
        if (headerStyle.hasOwnProperty('sticky')) {
          if (typeof headerStyle.sticky === 'object') {
            stickyInfo = { ...stickyInfo, ...headerStyle.sticky }
          } else if (typeof headerStyle.sticky === 'boolean') {
            if (!headerStyle.sticky) {
              stickyInfo = { isOn: false }
            } else {
              stickyInfo = { ...stickyInfo }
            }
          }
        }
      }

      if (this.$route.meta && this.$route.meta.headerStyle) {
        getHeaderStyle(this.$route.meta.headerStyle)
        if (this.isMobile && this.$route.meta.headerStyle.mobile) getHeaderStyle(this.$route.meta.headerStyle.mobile)
      }

      return { theme, rootPosition, stickyInfo }
    }
  }
}
</script>
